module.exports = __webpack_public_path__ + "img/main_slide_4.c9fc264c.png";